import React from 'react';

import PropTypes from 'prop-types';
import { Notification } from '@telus-uds/components-web';
import { FileUpload } from '@telus-uds/components-base';

import Label from './common/label';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const DefectAttachment = ({ fieldData, setFieldData }) => {
  const {
    reportAnIssue: {
      form: { labelAttachements, attachementsNote }
    }
  } = useLocalizedStringsContext();

  const handleUpload = async (files) => {
    setFieldData(previousValue => ({ ...previousValue, attachment: files[0] }));
    return files.map(f => f);
  };

  const handleDelete = async () => {
    setFieldData(previousValue => ({
      ...previousValue,
      attachment: ''
    }));
    return {};
  };

  return (
    <div>
      <Label labelName={`${labelAttachements}`} />
      <Notification variant={{ style: 'subtle' }}>{attachementsNote}</Notification>
      <FileUpload
        onUpload={handleUpload}
        onDelete={handleDelete}
      />
    </div>
  );
};

DefectAttachment.propTypes = {
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.shape({
      name: PropTypes.string
    })
  }).isRequired
};

export default DefectAttachment;
